<script>
import axios from 'axios';
import defaultAvatar from '@/assets/img/temp/user-dummy-img.jpg';

export default {
	data() {
		return {
			defaultAvatar,
			mem_data: [],
		};
	},
	computed: {
		profileImage() {
			return this.mem_data?.profile_image
				? `https://pphback.metacoresystemsinc.com/api${this.mem_data.profile_image}`
				: this.defaultAvatar;
		}
	},
	methods: {
		formatDate(dateString) {
			if (!dateString) return ""; // Handle empty values
			const date = new Date(dateString);
			if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid dates
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			const year = date.getFullYear();
			return `${month}/${day}/${year}`;
		},
	},
	async created() {
		const memberCode = this.$route.params?.code;
		try {
			const response = await axios.get(`https://pphback.metacoresystemsinc.com/api/verification/${memberCode}/`);
			this.mem_data = response.data;
		} catch (error) {
			console.error('Error fetching member data:', error);
		}
	}
};
</script>

<template>
	<div class="site-content">
		<div class="background-img">
			<!-- <img src="@/assets/img/main-img/shape3.png" alt="background-img" class="shape3">
			<img src="assets/images/main-img/shape5.png" alt="background-img" class="shape7"> -->
		</div>
		<section id="immigration-main" class="ceo-content">
			<div class="immigration-main-wrap">
				<div class="hero-sec-main">
					<div class="hero-top-sec">
						<img src="@/assets/img/banner/cover-pattern.png" alt="banner-img" class="w-100 bg-shape1" height="242">
						<img src="@/assets/img/banner/bg-img.png" alt="banner-img" class="w-100 bg-shape" height="160">
					</div>
					<div class="header-content">
						<div class="header-logo">
							<a href="index.html"><img src="@/assets/img/brand/pph_logo.png" alt="logo" height="45"></a>
						</div>
					</div>
				</div>
				<div class="hero-bottom-sec">
					<div class="client-content">
						<img :src="profileImage" alt="profile-picture" class="client-img" @error="(e) => e.target.src = defaultAvatar" />
						<h1 class="client-name mt-2" style="text-transform: uppercase;">{{ mem_data.partner_name }}</h1>
						<p class="client-title mt-2" style="font-weight:bold;">PARTNER NO. {{ mem_data.code }}</p>
						<p class="client-title mt-5" style="color: green; font-weight:bold">ACTIVE</p>
					</div>
				</div>
				<div class="contact-sec container mt-20">
					<div class="contact-sec-wrap">
						<div class="contact-bottom-sec">
							<div class="contact-details mt-10">
								<div class="contact-icon">
									<i class="ri-id-card-line" style="font-size: 22px; color:aliceblue; font-weight:500"></i>
								</div>
								<div class="contact-content" v-if="mem_data.staff_position !== null">
									<h4>Position</h4>
										<p class="mt-10">{{mem_data.office_position}}</p>
								</div>
								<div class="contact-content" v-else>
									<h4>Position</h4>
										<p class="mt-10">{{mem_data.latest_position}}</p>
								</div>
							</div>
							<div class="contact-details mt-10">
								<div class="contact-icon">
									<i class="ri-mail-send-line" style="font-size: 22px; color:aliceblue; font-weight:500"></i>
								</div>
								<div class="contact-content">
									<h4>Email Address</h4>
									<a :href="`mailto:${mem_data.username}`">
										<p class="mt-10">{{ mem_data.username }}</p>
									</a>
								</div>
							</div>
							<div class="contact-details mt-10">
								<div class="contact-icon">
									<i class="ri-phone-line" style="font-size: 22px; color:aliceblue; font-weight:500"></i>
								</div>
								<div class="contact-content">
									<h4>Mobile Number</h4>
									<a :href="`tel:${mem_data.mobile}`">
										<p class="mt-10">{{ mem_data.mobile }}</p>
									</a>
								</div>
							</div>
							<div class="contact-details mt-10">
								<div class="contact-icon">
									<i class="ri-creative-commons-nd-line" style="font-size: 22px; color:aliceblue; font-weight:500"></i>
								</div>
								<div class="contact-content">
									<h4>Accreditation Date</h4>
									<a href="tel:(555)555-1234">
										<p class="mt-10">{{ formatDate(mem_data.accredited_date) }}</p>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="appointment-bg mt-30 container">
					<div class="appointment-overlay"></div>
					<div class="appointment-content">
						<h2>Want to inquire more!</h2>
						<div class="view-product mt-30">
							<a href="https://philippinepropertyhomes.com/" target="_blank">more inquire!</a>
						</div>
					</div>
				</div>
				<div class="footer mt-10">
					<p style="color: black;">Philippine Property Homes</p>
				</div>
			</div>
		</section>
	</div>
</template>
